import React from 'react';
import { useNavigate } from 'react-router-dom';
import { baseURL } from '../../token';

const Runningbattles = ({ runnig, user, winnAmount }) => {
    const navigate = useNavigate();
    const gameAmount = Number(runnig?.Game_Ammount) || 0;
    const prizeAmount = gameAmount + (Number(winnAmount?.(gameAmount)) || 0);
    const avatarStyle = {
        width: '34px',
        height: '34px',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '1px solid #dfe7ec'
    };

    return (
        <div
            className="col-12 card my-2 walletcard px-0 mx-auto text-black border-0 overflow-hidden"
            style={{
                borderRadius: '14px',
                background: '#ffffff',
                boxShadow: '0 3px 10px rgba(0, 0, 0, 0.06)',
                border: '1px solid #e8ecef'
            }}
        >
            <div className="row align-items-center g-0 px-1 pt-3 pb-2" style={{ borderBottom: '1px solid #edf1f4' }}>
                {/* <div className="col-lg-9 d-flex align-items-center justify-content-start flex-wrap gap-2">
                    <span className="mb-0 d-flex align-items-center" style={{ fontSize: '14px', fontWeight: '700', letterSpacing: '0.2px' }}>
                        PLAYING FOR&nbsp;<span className="material-symbols-outlined text-success">payments</span>&nbsp;{gameAmount}
                    </span>
                </div> */}
                {/* <div className="col-lg-3 d-flex justify-content-end pt-2 pt-lg-0" style={{ paddingRight: '16px' }}>
                    <p className="mb-0" style={{ fontSize: '13px', fontWeight: '700' }}>Prize&nbsp; {prizeAmount}</p>
                </div> */}
            </div>

            <div className="card-body walletbody px-1 py-2">
                <div className="row align-items-stretch   g-2">
                    <div className="col-4 d-flex align-items-center" style={{ minHeight: '96px' }}>
                            <img
                                src={"/images/img.jpg"}
                                alt={runnig?.Created_by?.Name || 'Player 1'}
                                style={avatarStyle}
                                className="me-2"
                            />
                      
                
                        <p className="text-black mb-0" style={{ lineHeight: '1.3', fontSize: '14px', fontWeight: '700', wordBreak: 'break-word' }}>
                            {runnig?.Created_by?.Name}
                        </p>
                    </div>
                    <div
                        className="col-4 d-flex flex-column align-items-center justify-content-center"
                        style={{
                            minHeight: '96px',
                            borderRadius: '12px',
                            background: 'linear-gradient(180deg, #f4fbf7 0%, #eef7ff 100%)',
                            border: '1px solid #e3edf2'
                        }}
                    >
                        <span className="badge text-success px-2 py-1" style={{ fontSize: '12px', fontWeight: '800', backgroundColor: '#eaf8ef' }}>
                            Bet: {gameAmount}
                        </span>
                        <img src="/images/versus.png" className="my-1" style={{ width: '34px', height: '34px', objectFit: 'contain' }} alt="VS" />
                        <span className="badge text-success px-2 py-1" style={{ fontSize: '12px', fontWeight: '800', backgroundColor: '#eaf8ef' }}>
                            Won: {prizeAmount}
                        </span>
                        {(user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id) && (
                            <button
                                className={`${runnig?.Status === 'conflict' ? 'bg-danger' : 'bg-success'} mt-2`}
                                style={{ width: '92px', height: '34px', fontSize: '12px', border: 'none', borderRadius: '7px', fontWeight: '600', color: '#fff' }}
                                onClick={() => navigate(`/viewgame/${runnig?._id}`, { state: { prevPath: window.location.pathname } })}
                            >
                                View
                            </button>
                        )}
                    </div>
                    <div className="col-4 d-flex align-items-center  justify-content-end" style={{ minHeight: '96px' }}>
                        <p className="text-black text-end mr-2 mb-0" style={{ lineHeight: '1.3', fontSize: '14px', fontWeight: '700', wordBreak: 'break-word' }}>
                            {runnig?.Accepetd_By?.Name}
                        </p>
                       <img
                                src={"/images/img.jpg"}
                                alt={runnig?.Created_by?.Name || 'Player 1'}
                                style={avatarStyle}
                                className="me-2"
                            />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Runningbattles;